import { render } from "./DescriptionComponent.vue?vue&type=template&id=ea2ea012"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=ea2ea012&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__